import React, { Component } from "react";

import {
  CButton,
  CFormGroup,
  CLabel,
  CModal,
  CModalBody,
  CModalHeader,
  CModalTitle,
  CSpinner,
  CTextarea
} from "@coreui/react";
import ReactDOM from "react-dom";
import { connect } from "react-redux";
import { toastr } from "react-redux-toastr";
import { bindActionCreators } from "redux";

import { logout } from "../../actions/baseActions";
import { setObj } from "../../actions/noteActions";
import URL from "../../config/api";
import axios from "../../config/axios";
import {
  descricaoParaEditor,
  temFormatoDeEditor
} from "../../utils/descricaoAtividade";
import ActivityCreator from "../ActivityCreator";

const appRoot = document.getElementById("root");

class EditNodeModal extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: true,
      types: []
    };

    this.el = document.createElement("div");
    this.error = this.error.bind(this);
  }

  error(response) {
    if (response === "Unauthorized") {
      this.props.logout(this.props.user.token);
    } else {
      toastr.error("Falha", response);
    }
  }

  setValorDescrição(val) {
    this.setState({
      // ValorDescricao: val
    });
  }

  componentDidMount() {
    appRoot.appendChild(this.el);

    const { id } = this.props;
    let contentType = null;
    if (contentType) {
      this.setState({
        // contentType
      });
    }

    let objDisciplinesList = {
      user_id: this.props.user.user.id
    };

    let objCriterionsList = {
      user_id: this.props.user.user.id
    };

    axios
      .all([
        axios.get(`${URL.api}content/type/list`, {
          headers: { authorization: `Bearer ${this.props.user.token}` }
        }),
        axios.post(`${URL.api}community/room_user/list`, objDisciplinesList, {
          headers: { authorization: `Bearer ${this.props.user.token}` }
        }),
        axios.get(`${URL.api}activity/type/list`, {
          headers: { authorization: `Bearer ${this.props.user.token}` }
        }),
        axios.get(`${URL.api}classification/discipline/list`, {
          headers: { authorization: `Bearer ${this.props.user.token}` }
        }),
        axios.get(`${URL.api}literarte/text_types`, {
          headers: { authorization: `Bearer ${this.props.user.token}` }
        }),
        axios.post(`${URL.api}literarte/criterions`, objCriterionsList, {
          headers: { authorization: `Bearer ${this.props.user.token}` }
        })
      ])
      .then(
        axios.spread(
          (
            respType,
            respRoomUser,
            respActivityType,
            respDiscipline,
            respTextTypes,
            respTextCriterions
          ) => {
            if (respType.data.success && respActivityType.data.success) {
              let textTypesList = [];
              respTextTypes.data.data.forEach(type => {
                textTypesList.push(type);
              });

              let textCriterionsList = [];
              respTextCriterions.data.data[0].forEach(criterion => {
                criterion.visible = true;
                textCriterionsList.push(criterion);
              });

              respTextCriterions.data.data[1].forEach(criterion => {
                criterion.visible = true;
                textCriterionsList.push(criterion);
              });

              let types = [];
              respType.data.data.forEach(type => {
                if (type.activity === true) {
                  if (type.name === "Avaliação") {
                    type.name = "Exercício";
                  }

                  if (
                    type.id === 9 &&
                    this.props.user.user_modules?.find(
                      module => module.id === 11
                    )
                  ) {
                    types.push(type);
                  } else if (
                    this.props.user.user_modules?.find(
                      module => module.id === 2
                    )
                  ) {
                    types.push(type);
                  } else if (type.id === 18 || type.id === 12) {
                    types.push(type);
                  }
                }
              });

              let disciplinesList = [];

              if (
                ["G", "U", "R", "E"].includes(
                  this.props.general.active_roles.type
                )
              ) {
                disciplinesList = respDiscipline.data.data.map(discipline => ({
                  id: discipline.id,
                  name: discipline.name
                }));
              } else {
                let check;
                for (let i = 0; i < respRoomUser.data.data.length; i++) {
                  for (
                    let j = 0;
                    j < respRoomUser.data.data[i].disciplines.length;
                    j++
                  ) {
                    check = true;
                    for (let k = 0; k < disciplinesList.length; k++) {
                      if (
                        disciplinesList[k].id ===
                        respRoomUser.data.data[i].disciplines[j].discipline_id
                      ) {
                        check = false;
                        break;
                      }
                    }

                    if (check) {
                      disciplinesList.push({
                        id: respRoomUser.data.data[i].disciplines[j]
                          .discipline_id,
                        name: respRoomUser.data.data[i].disciplines[j]
                          .discipline_name
                      });
                    }
                  }
                }
              }

              const activityTypes = respActivityType.data.data;

              this.setState({
                types
              });
            }
          },
          error => {
            this.error(error.response.statusText);
          }
        )
      );

    if (id) {
      this.setState(
        () => ({
          // edit: true
        }),
        () => {
          axios
            .get(`${URL.api}activity/activity/singleView/${id}`, {
              headers: { authorization: `Bearer ${this.props.user.token}` }
            })
            .then(respActivity => {
              let contentList = [];
              for (let i = 0; i < respActivity.data.data.items.length; i++) {
                let obj = {
                  type: respActivity.data.data.items[i].type_id,
                  list: {
                    id: respActivity.data.data.items[i].obj_id,
                    name: respActivity.data.data.items[i].name
                  },
                  link: respActivity.data.data.items[i].link
                };
                contentList.push(obj);
              }

              let types = [];
              if (respActivity.data.data.type_id === 3) {
                this.state.types.forEach(type => {
                  if (type.id === 12) {
                    types.push(type);
                  }
                });
              } else {
                this.state.types.forEach(type => {
                  types.push(type);
                });
              }

              // A descrição chega em quatro formatos e `null` é um deles — toda
              // atividade criada por "Minhas trilhas" sem descrição. O `substring`
              // direto no valor da API estourava aqui e o modal não abria. Ver
              // `utils/descricaoAtividade.js`; o `"paragaph"` (sem "r") é o tipo que
              // este arquivo sempre gravou e vai ao banco dentro do JSON.
              const nosDaDescricao = descricaoParaEditor(
                respActivity.data.data.description,
                "paragaph"
              );
              if (!temFormatoDeEditor(respActivity.data.data.description)) {
                respActivity.data.data.description =
                  JSON.stringify(nosDaDescricao);
              }
              this.setValorDescrição(nosDaDescricao);

              this.setState(() => ({
                loading: false,
                types
              }));
            });
        }
      );
    } else {
      this.setState({
        loading: false
      });
    }
  }

  componentWillUnmount() {
    appRoot.removeChild(this.el);
  }

  render() {
    return ReactDOM.createPortal(
      <CModal
        show={this.props.show}
        onClose={() => this.props.onClose()}
        size="lg"
        centered
        style={{ overflow: "visible" }}
        closeOnBackdrop={false}
      >
        <CModalHeader closeButton>
          <CModalTitle>
            {this.props.id ? "Editar" : "Criar"} atividade
          </CModalTitle>
        </CModalHeader>
        <CModalBody style={{ overflow: "visible" }}>
          {this.state.loading ? (
            <div className="h-100 w-100 d-flex align-items-center justify-content-center p-4">
              <CSpinner size="md" color="secondary" />
            </div>
          ) : (
            <ActivityCreator {...this.props} trailModal />
          )}
        </CModalBody>
      </CModal>,
      this.el
    );
  }
}

const mapStateToProps = state => ({
  user: state.user,
  general: state.general,
  profile: state.profile
});

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      logout,
      setObj
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(EditNodeModal);
